import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listadoTemasSelector, clienteActivoSelector, setTheme } from '../store/theme';
import { listadoEstilosSelector, tipoEstiloSelector, setStyle } from '../store/layout';
import FloatingWindow from './FloatingWindow';
import SelectField from './SelectField';
import { Stack } from '@mui/material';

function ConfigMenu() {
    const dispatch = useDispatch();
    const listadoTemas = useSelector(listadoTemasSelector);
    const clienteActivo = useSelector(clienteActivoSelector);
    
    const listadoEstilos = useSelector(listadoEstilosSelector);
    const tipoEstilo = useSelector(tipoEstiloSelector);

    const [open, setOpen] = useState(false);
    useEffect(() => {
        const theme = localStorage.getItem('theme');
        const style = localStorage.getItem('style');
        if(theme !== clienteActivo && listadoTemas.map(t=>t.code).includes(theme)){
            dispatch(setTheme(theme));
        }
        if(style !== tipoEstilo && listadoEstilos.map(s=>s.code).includes(style)){
            dispatch(setStyle(style));
        }
    },[]);
    
    const handleTheme = (e) => {
        const theme = e.target.value;
        dispatch(setTheme(theme));
        localStorage.setItem("theme", theme);
    }
    const handleStyle = (e) => {
        const style = e.target.value;
        dispatch(setStyle(style));
        localStorage.setItem("style", style);
    }

    const themeControl = {
		title: 'Tema',
		nullText: 'No ingresada',
		data: clienteActivo,
		id: 'theme',
		type: 'select',
		validation: {
			valid: true,
			text: '',

		},
	};
    
    const styleControl = {
		title: 'Estilo',
		nullText: 'No ingresada',
		data: tipoEstilo,
		id: 'style',
		type: 'select',
		validation: {
			valid: true,
			text: '',

		},
	};
    return (<FloatingWindow open={open} setOpen={setOpen} >
        <Stack>
            <SelectField 
                showValidation={false} 
                control={themeControl} 
                handleChange={handleTheme} 
                options={listadoTemas}
            />
            <SelectField
                showValidation={false} 
                control={styleControl} 
                handleChange={handleStyle} 
                options={listadoEstilos}
            />
        </Stack>
    </FloatingWindow>);
}

export default ConfigMenu;